<template>
  <el-card>
    <div
        slot="header"
        class="clearfix"
    >
      <span>Adóhatósági ellenőrzési adatszolgáltatás</span>
    </div>
    <nav-audit-list/>
  </el-card>
</template>

<script>
import NavAuditList from '../../components/reports/navAudit/List';

export default {
  components: {
    NavAuditList,
  },
  data() {
    return {
    };
  },


};
</script>
